import ApplicationController from './application_controller';

/*
 * Co-signature Request Row Controller
 *
 * One manual co-signature request row in the co-signature modal
 * (app/views/signature_requests/_signature_request_fields.html.erb).
 *
 * "Use for billing" makes the co-signer the rendering provider on the claim, so SignatureRequest only accepts it
 * for a fully licensed co-signer. Rather than let the author submit, fail, and lose every row in the modal, this
 * unticks and disables the checkbox as soon as an assistant is picked. The server validation stays the backstop.
 *
 * The select is an Impulse select, which reports a pick with `awc-autocomplete:commit`.
 */
export default class extends ApplicationController {
  static targets = ['select', 'billing'];

  static values = { billingEligibleIds: Array };

  connect() {
    this.sync();
  }

  sync(event) {
    if (!this.hasBillingTarget) return;

    const selected = event?.detail?.value ?? this.selectedValue;
    // Nobody picked yet: leave it usable. The select is required, so a blank row cannot be submitted.
    const eligible = selected === '' || this.billingEligibleIdsValue.includes(selected);

    if (!eligible) this.billingTarget.checked = false;
    this.billingTarget.disabled = !eligible;
  }

  // The select is an `<awc-autocomplete>` custom element; read its committed
  // value from the hidden input so this works even before the element upgrades.
  get selectedValue() {
    if (!this.hasSelectTarget) return '';

    const hiddenField = this.selectTarget.querySelector('input[data-behavior="hidden-field"]');
    return hiddenField ? hiddenField.value : '';
  }
}
